import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CreditStatus } from 'src/app/@core/constants';
import { CreditRequest } from 'src/app/models/credit-request';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';

@Component({
  selector: 'app-bank-representative-step',
  templateUrl: './bank-representative-step.component.html',
  styleUrls: ['./bank-representative-step.component.sass']
})
export class BankRepresentativeStepComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() bankRepresentativeForm: FormGroup = new FormGroup({
    mainRequestCode: new FormControl("", Validators.required)
  });
  @Input() disabled: boolean = false;
  @Input() isEdit: boolean = false;
  creditRequestNumber: string = "";
  showDetail: boolean = false;
  constructor(private toastr: ToastrService, private readonly exceptionSolutionService: ExceptionSolutionService) { }

  ngOnInit(): void {
    this.bankRepresentativeForm.get("mainRequestCode")?.setValidators(Validators.required);
    this.bankRepresentativeForm.markAsDirty();
    if (this.isEdit && this.bankRepresentativeForm.value.mainRequestCode) {
      this.searchRequest();
    }
  }

  ngAfterViewInit(): void {

  }
  ngOnDestroy(): void {
    this.bankRepresentativeForm.get("mainRequestCode")?.clearValidators();
    this.bankRepresentativeForm.reset();
    this.showDetail = false;
  }

  searchRequest() {
    this.creditRequestNumber = this.bankRepresentativeForm.value.mainRequestCode;
    this.showDetail = true;
  }

  getRequest(request: CreditRequest) {
    if (!request.code) {
      this.bankRepresentativeForm.reset();
      this.showDetail = false;
    }

    const isAcceptedOrReject = request.status.filter(f => f == CreditStatus.APPROVED || f == CreditStatus.REJECTED).length > 0;

    if (isAcceptedOrReject) {
      this.bankRepresentativeForm.reset();
      this.showDetail = false;
      this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito`, `Esta solicitud ya esta procesada y no puede ser utilizada. Selecciona otra solicitud que esté en proceso.`);
    }

    if (request.processingStatus == "DRAFT") {
      this.bankRepresentativeForm.reset();
      this.showDetail = false;
      this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito`, `Esta solicitud esta en borradores y no puede ser utilizada. Selecciona otra solicitud que esté en proceso.`);
    }
  }
}

